const balancesActionTypes = {
  GET_USER_BALANCES_START: 'GET_USER_BALANCES_START',
  GET_USER_BALANCES_SUCCESS: 'GET_USER_BALANCES_SUCCESS',
  GET_USER_BALANCES_FAIL: 'GET_USER_BALANCES_FAIL',

  GET_DEPOSIT_DATA_START: 'GET_DEPOSIT_DATA_START',
  GET_DEPOSIT_DATA_SUCCESS: 'GET_DEPOSIT_DATA_SUCCESS',
  GET_DEPOSIT_DATA_FAIL: 'GET_DEPOSIT_DATA_FAIL',

  GET_TOKENS_LIST_START: 'GET_TOKENS_LIST_START',
  GET_TOKENS_LIST_SUCCESS: 'GET_TOKENS_LIST_SUCCESS',
  GET_TOKENS_LIST_FAIL: 'GET_TOKENS_LIST_FAIL',

  GET_TOKENS_LIST_BY_SEARCH_VALUE_START: 'GET_TOKENS_LIST_BY_SEARCH_VALUE_START',
  GET_TOKENS_LIST_BY_SEARCH_VALUE_END: 'GET_TOKENS_LIST_BY_SEARCH_VALUE_END',

  GET_WITHDRAW_START: 'GET_WITHDRAW_START',
  GET_WITHDRAW_SUCCESS: 'GET_WITHDRAW_SUCCESS',
  GET_WITHDRAW_FAIL: 'GET_WITHDRAW_FAIL',

  GET_TRANSACTIONS_HISTORY_START: 'GET_TRANSACTIONS_HISTORY_START',
  GET_TRANSACTIONS_HISTORY_SUCCESS: 'GET_TRANSACTIONS_HISTORY_SUCCESS',
  GET_TRANSACTIONS_HISTORY_FAIL: 'GET_TRANSACTIONS_HISTORY_FAIL',
};

export default balancesActionTypes;
